module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/CHEMISTRY-31e731724763dc7ce13d109fb2f8511d.png";